var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    d: "M16.1416 17.8555C16.3783 17.8555 16.5703 18.0475 16.5703 18.2842V25.4268H11.4277V18.2842C11.4277 18.0476 11.6199 17.8556 11.8564 17.8555H16.1416ZM13.999 2.5C15.5843 2.5 16.9154 3.64133 19.5771 5.92285L21.0059 7.14746C22.4781 8.40937 23.2143 9.04039 23.6064 9.89258C23.9985 10.745 23.999 11.715 23.999 13.6543V19.7119C23.999 22.4055 23.9989 23.753 23.1621 24.5898C22.3554 25.3964 21.0745 25.4247 18.5703 25.4258V18.2842C18.5703 16.9429 17.4828 15.8555 16.1416 15.8555H11.8564C10.5153 15.8556 9.42773 16.943 9.42773 18.2842V25.4258C6.92366 25.4247 5.64259 25.3965 4.83594 24.5898C3.9992 23.753 4 22.4055 4 19.7119V13.6543C4 11.715 3.99956 10.745 4.3916 9.89258C4.78371 9.04027 5.52069 8.40959 6.99316 7.14746L8.4209 5.92285C11.0826 3.64142 12.4138 2.5001 13.999 2.5Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.40c0dbad4c5b98fa820c693e287272a2.svg";
export { ForwardRef as ReactComponent };